import React from "react";
import { motion } from "framer-motion";

export function SectionTitle({ eyebrow, title, subtitle, right, testid }) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6" data-testid={testid}>
      <div>
        {eyebrow && (
          <div className="text-[11px] uppercase tracking-[0.22em] gold-text font-num mb-2">{eyebrow}</div>
        )}
        <h2 className="font-display font-black text-2xl sm:text-3xl tracking-tight text-white">{title}</h2>
        {subtitle && <p className="text-muted-foreground mt-1 text-sm max-w-xl">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}

export function Panel({ className = "", children, glow, ...rest }) {
  return (
    <div
      className={`croc-panel p-6 ${glow === "gold" ? "glow-gold" : glow === "emerald" ? "glow-emerald" : ""} ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export function StatCard({ label, value, sub, icon: Icon, accent = "emerald", testid, delay = 0 }) {
  const color = accent === "gold" ? "text-[#1CFD4C]" : "text-[#34D399]";
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay }}
      className="croc-panel p-5"
      data-testid={testid}
    >
      <div className="flex items-center justify-between">
        <span className="text-[11px] uppercase tracking-widest text-muted-foreground">{label}</span>
        {Icon && <Icon className={`w-4 h-4 ${color}`} />}
      </div>
      <div className={`font-num font-bold text-2xl mt-3 ${color}`}>{value}</div>
      {sub && <div className="text-xs text-muted-foreground mt-1">{sub}</div>}
    </motion.div>
  );
}

export function Pill({ children, tone = "neutral", className = "", ...rest }) {
  const tones = {
    gold: "bg-[#1CFD4C]/12 text-[#1CFD4C] border-[#1CFD4C]/30",
    emerald: "bg-[#10B981]/12 text-[#34D399] border-[#10B981]/30",
    danger: "bg-red-500/12 text-red-400 border-red-500/30",
    neutral: "bg-white/5 text-muted-foreground border-white/10",
  };
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-num border ${tones[tone]} ${className}`}
      {...rest}
    >
      {children}
    </span>
  );
}
